"use strict";

exports.__esModule = true;
exports.ScheduleNameField = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactFinalForm = require("react-final-form");
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var ScheduleNameField = exports.ScheduleNameField = function ScheduleNameField() {
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
    name: "name"
  }, function (_ref) {
    var input = _ref.input,
      meta = _ref.meta;
    return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      intent: meta.touched && meta.error ? "danger" : "secondary",
      helperText: meta.touched && meta.error ? meta.error : translate("ScheduleNameField.helperText", "The name of this schedule."),
      label: translate("ScheduleNameField.label", "Name"),
      labelFor: "name",
      requiredLabel: "*"
    }, /*#__PURE__*/_react["default"].createElement(_core.InputGroup, _extends({
      type: "text",
      style: {
        maxWidth: 300
      }
      // eslint-disable-next-line jsx-a11y/no-autofocus
      ,
      autoFocus: true
    }, input)));
  });
};